<app-header (selectedLang)="getLanguage($event)"></app-header>
<div class="mis_view">
  <div class="container-fluid">
    <div class="container-fluid">
      <div class="header_mis">
        <div class="row">          
                <div class="col-12">
                  <nav aria-label="breadcrumb" class="float-left d-flex w-100">
                    <ol class="breadcrumb breadcrumb-right-panel mb-2">
                      <li class="breadcrumb-item"><a href="/gis">{{'submitdata.Home' | translate}}</a></li>
                      <li class="breadcrumb-item active" aria-current="page">{{'submitdata.Submit Data' | translate}}
                      </li>
                    </ol>

                    <!-- <ol class="flex-fill col-10 my-auto" style="color: #FFFFFF;"
              *ngIf="Urlparams['component']== 'forminput' && showMarque">
              <marquee width=100% direction="left" scrollamount="3" Onmouseover="this.stop()" onmouseout="this.start()">
                <b>The last date for districts for submission of data for the assessment year {{yearMonth.ay}} for the 
                  month of {{currentMonth}} is</b>:
                  <b>{{formatdate(timeWindow['edate'])}}</b>
              </marquee>
            </ol>
            <ol class="flex-fill col-10 my-auto" style="color: #FFFFFF;"
              *ngIf="Urlparams['component']== 'forminput' && !showMarque">
              <marquee width=100% direction="left" scrollamount="3" Onmouseover="this.stop()" onmouseout="this.start()">
                <b>The last date for districts for submission of data for the assessment year {{yearMonth.ay}} for the 
                  month of {{currentMonth}} is not set by admin.</b>
              </marquee>
            </ol> -->

                    <ol class="flex-fill col-10 my-auto" style="color: #FFFFFF;"
                      *ngIf="userDetails['roles'][0] == 'STATE_NODAL_OFFICER' && multiyeardata!=null">
                      <marquee width=100% direction="left" scrollamount="3" Onmouseover="this.stop()"
                        onmouseout="this.start()">
                        <b>The last date for states/UT for submission of data for the assessment year 2019-2020
                          is</b>:<b>{{formatdate(multiyeardata)}}</b>
                      </marquee>
                    </ol>
                    <ol class="flex-fill col-10 my-auto" style="color: #FFFFFF;"
                      *ngIf="userDetails['roles'][0] == 'STATE_NODAL_OFFICER' && multiyeardata==null">
                      <marquee width=100% direction="left" scrollamount="3" Onmouseover="this.stop()"
                        onmouseout="this.start()">
                        <b>{{dateMsg}}</b>
                      </marquee>
                    </ol>
                    <ol class="flex-fill col-10 my-auto" style="color: #FFFFFF;"
                      *ngIf="userDetails['roles'][0] == 'DISTRICT_NODAL_OFFICER' && multiyeardata!=null">
                      <marquee width=100% direction="left" scrollamount="3" Onmouseover="this.stop()"
                        onmouseout="this.start()">
                        <b>The last date for districts for submission of data for the assessment year 2019-2020
                          is</b>:<b>{{formatdate(multiyeardata)}}</b>
                      </marquee>
                    </ol>
                    <ol class="flex-fill col-10 my-auto" style="color: #FFFFFF;"
                      *ngIf="userDetails['roles'][0] == 'DISTRICT_NODAL_OFFICER' && multiyeardata==null">
                      <marquee width=100% direction="left" scrollamount="3" Onmouseover="this.stop()"
                        onmouseout="this.start()">
                        <b>{{dateMsg}}</b>

                      </marquee>
                    </ol>
                  </nav>
                </div>
                <div class="col-2" *ngIf="showindiawris">
                  <button style="float: right" class="btn btn-info pointer" type="submit"><a target="_blank"
                      style="color:white;text-decoration: none;" href="https://indiawris.gov.in/wris/#/waterData"><img
                        src="../assets/images/india_wris.png" style="height: 20px;"> India WRIS</a></button>
                </div>
              </div>

              <div class="row h-100">
                <div class="col-12 col-xl-2 col-md-12 m-0 h-100">
                  <div class="card blue_shadow sidebar-container">
                    <div class="card-body">
                      <ul class="sidebarlist">
                        <!-- <li>
                <a *ngIf="checkuserValid('downloadexcel')" name="downloadexcel"
                  [ngClass]="{'activesidetab': Urlparams['component'] == 'downloadexcel'}"
                  (click)="setcomponent('downloadexcel')"> <i class="fas fa-file-excel"></i> &nbsp;Excel Download
                  Template </a>
              </li>
              <li>
                <a *ngIf="checkuserValid('uploadexcel')" name="excelupload"
                  [ngClass]="{'activesidetab': Urlparams['component'] == 'uploadexcel'}"
                  (click)="setcomponent('uploadexcel')"> <i class="fas fa-file-excel"></i> &nbsp;Excel Upload </a>
              </li> -->
                        <li>
                          <a *ngIf="checkuserValid('forminput')" name="forminput"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'forminput'}"
                            (click)="setcomponent('forminput')"> <i class="fa fa-poll-h"></i>
                            &nbsp;{{'componentPages.dataentry' | translate}}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('datasubmitapprovals')" name="datasubmitapprovals"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'datasubmitapprovals'}"
                            (click)="setcomponent('datasubmitapprovals')"> <i class="fa fa-user-check"></i>
                            {{'componentPages.datasubmit' | translate}}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('requestextension')" name="requestextension"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'requestextension'}"
                            (click)="setcomponent('requestextension')"><i class="fas fa-edit"></i>
                            &nbsp;{{'componentPages.request' | translate}}
                          </a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('shapefileupload')" name="shapefileupload"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'shapefileupload'}"
                            (click)="setcomponent('shapefileupload')"> <i class="fa fa-file-upload"></i>
                            &nbsp;{{'componentPages.shapefile' | translate}}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('approvals')" name="approvals"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'approvals'}"
                            (click)="setcomponent('approvals')"> {{'componentPages.approvals' | translate}} </a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('weightage-edits')" name="weightage-edits"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'weightage-edits'}"
                            (click)="setcomponent('weightage-edits')"> {{'componentPages.editweight' | translate}} </a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('adminlistofDGCs')" name="adminlistofDGCs"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'adminlistofDGCs'}"
                            (click)="setcomponent('adminlistofDGCs')">{{'listofdgc.List of DGCs' | translate }} </a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('admin-dgcreports')" name="admin-dgcreports"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'admin-dgcreports'}"
                            (click)="setcomponent('admin-dgcreports')">{{'componentPages.Admin DGC Report' | translate }}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('meetingmodule')" name="meetingmodule"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'meetingmodule'}"
                            (click)="setcomponent('meetingmodule')">{{'componentPages.meetingreports' | translate}}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('meetingstatus')" name="meetingstatus"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'meetingstatus'}"
                            (click)="setcomponent('meetingstatus')">{{'componentPages.Meeting Status Reports' | translate}}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('meeting-attendance-report')" name="meeting-attendance-report"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'meeting-attendance-report'}"
                            (click)="setcomponent('meeting-attendance-report')">{{'componentPages.Meeting Attendance Report' | translate}}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('broadcasting')" name="broadcasting"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'broadcasting'}"
                            (click)="setcomponent('broadcasting')">{{'broadcasting.Upload Documents for Broadcasting' | translate }}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('extensionapproval')" name="extensionapproval"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'extensionapproval'}"
                            (click)="setcomponent('extensionapproval')"> {{'componentPages.timewindow' | translate}}
                          </a>
                        </li>
                        <!-- <li>
                          <a *ngIf="checkuserValid('summary')" name="summary"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'summary'}"
                            (click)="setcomponent('summary')">{{'componentPages.approvals' | translate}} </a>
                        </li> -->
                        <li>
                          <a *ngIf="checkuserValid('edit-weightage')" name="edit-weightage"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'edit-weightage'}"
                            (click)="setcomponent('edit-weightage')"> {{'componentPages.editweight' | translate}} </a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('dynamicindicator')" name="dynamicindicator"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'dynamicindicator'}"
                            (click)="setcomponent('dynamicindicator')">{{'componentPages.dynamicind' | translate}} </a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('usermanagement')" name="usermanagement"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'usermanagement'}"
                            (click)="setcomponent('usermanagement')">{{'componentPages.usermanagement' | translate}}
                          </a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('mandatorythemes')" name="mandatorythemes"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'mandatorythemes'}"
                            (click)="setcomponent('mandatorythemes')">{{ 'themeandassessment.Themes Mandatory & Assessment Year' | translate}}</a>
                        </li>
                        <!-- <li>
                          <a *ngIf="checkuserValid('triggercomputations')" name="triggercomputations"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'triggercomputations'}"
                            (click)="setcomponent('triggercomputations')"> {{'componentPages.trigger' | translate}} </a>
                        </li> -->
                        <li>
                          <a *ngIf="checkuserValid('manualintervention')" name="manualintervention"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'manualintervention'}"
                            (click)="setcomponent('manualintervention')"> {{'componentPages.manualIVA' | translate}}
                          </a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('aggregationreports')" name="aggregationreports"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'aggregationreports'}"
                            (click)="setcomponent('aggregationreports')">{{'componentPages.aggregated' | translate}}</a>
                        </li>
                        <!-- <li>
                          <a *ngIf="checkuserValid('aggregationadmin')" name="aggregationadmin"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'aggregationadmin'}"
                            (click)="setcomponent('aggregationadmin')">{{'componentPages.admin' | translate}}</a>
                        </li> -->                        
                        <li>
                          <a *ngIf="checkuserValid('state-dgcreports')" name="state-dgcreports"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'state-dgcreports'}"
                            (click)="setcomponent('state-dgcreports')">{{ 'componentPages.state DGC Report' | translate }}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('meetingreport')" name="meetingreport"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'meetingreport'}"
                            (click)="setcomponent('meetingreport')">{{'componentPages.meetingreports' | translate}}</a>
                        </li>
                        
                        <li>
                          <a *ngIf="checkuserValid('uploadreport')" name="uploadreport"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'uploadreport'}"
                            (click)="setcomponent('uploadreport')">{{ 'broadcasting.Upload Consolidated Meeting Report' | translate }}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('statelistofDGCs')" name="statelistofDGCs"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'statelistofDGCs'}"
                            (click)="setcomponent('statelistofDGCs')">{{ 'listofdgc.List of DGCs' | translate }}</a>
                        </li>
                        <li>
                          <a *ngIf="checkuserValid('dgcmeetingreports')" name="dgcmeetingreports"
                            [ngClass]="{'activesidetab': Urlparams['component'] == 'dgcmeetingreports'}"
                            (click)="setcomponent('dgcmeetingreports')">{{ 'listofdgc.DGC Meeting Report' | translate }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-xl-10 col-md-12" style="min-height: calc(100vh - 240px);">
                  <div class="card blue_shadow p-3">
                    <!-- depends on component -->
                    <app-statemeeting-reports *ngIf="Urlparams && Urlparams['component']== 'meetingreport'">
                    </app-statemeeting-reports>
                    <app-datasubmitapprovals *ngIf="Urlparams && Urlparams['component']== 'datasubmitapprovals'">
                    </app-datasubmitapprovals>
                    <!-- <app-exceldownload *ngIf="Urlparams && Urlparams['component']== 'exceldownload'"></app-exceldownload> -->
                    <!-- <app-excelupload *ngIf="Urlparams && Urlparams['component']== 'excelupload'"></app-excelupload> -->
                    <app-shapefileupload *ngIf="Urlparams && Urlparams['component']== 'shapefileupload'">
                    </app-shapefileupload>
                    <app-forminput *ngIf="Urlparams && Urlparams['component']== 'forminput'"></app-forminput>
                    <app-adminpage *ngIf="Urlparams && Urlparams['component']== 'summary'"></app-adminpage>
                    <app-approvals *ngIf="Urlparams && Urlparams['component']== 'approvals'"></app-approvals>
                    <app-edit-weightage *ngIf="Urlparams && Urlparams['component']== 'edit-weightage'">
                    </app-edit-weightage>
                    <app-dynamicindicator *ngIf="Urlparams && Urlparams['component']== 'dynamicindicator'">
                    </app-dynamicindicator>
                    <app-user-list *ngIf="Urlparams && Urlparams['component']== 'usermanagement'"></app-user-list>
                    <app-trigger-computations *ngIf="Urlparams && Urlparams['component']== 'triggercomputations'">
                    </app-trigger-computations>
                    <app-request-extension *ngIf="Urlparams && Urlparams['component']== 'requestextension'">
                    </app-request-extension>
                    <app-extension-approval [selectedlanguage]="lang"
                      *ngIf="Urlparams && Urlparams['component']== 'extensionapproval'">
                    </app-extension-approval>
                    <app-dvm-weightageedits *ngIf="Urlparams && Urlparams['component']== 'weightage-edits'">
                    </app-dvm-weightageedits>
                    <!-- <app-dvmedit-weightage  *ngIf="Urlparams && Urlparams['component']== 'dvm-edit-weightage'"></app-dvmedit-weightage> -->
                    <!-- <app-manual-intervention-data *ngIf="Urlparams && Urlparams['component']== 'manualinterventiondata'"></app-manual-intervention-data> -->
                    <app-manual-intervention *ngIf="Urlparams && Urlparams['component']== 'manualintervention'">
                    </app-manual-intervention>
                    <app-aggregation-reports *ngIf="Urlparams && Urlparams['component']== 'aggregationreports'">
                    </app-aggregation-reports>
                    <app-aggregated-admin-reports *ngIf="Urlparams && Urlparams['component']== 'aggregationadmin'">
                    </app-aggregated-admin-reports>
                    <app-download-excel *ngIf="Urlparams && Urlparams['component']== 'downloadexcel'">
                    </app-download-excel>
                    <app-upload-excel *ngIf="Urlparams && Urlparams['component']== 'uploadexcel'"></app-upload-excel>
                    <!-- <app-meeting-module *ngIf="Urlparams && Urlparams['component']== 'meetingmodule'" ></app-meeting-module> -->
                    <app-adminmeeting-module *ngIf="Urlparams && Urlparams['component']== 'meetingmodule'">
                    </app-adminmeeting-module>
                    <app-meetingreport-status *ngIf="Urlparams && Urlparams['component']== 'meetingstatus'" [selectedlanguage]="lang">
                    </app-meetingreport-status>
                    <app-uploadconsolidate-meeting-reports *ngIf="Urlparams && Urlparams['component']== 'uploadreport'">
                    </app-uploadconsolidate-meeting-reports>
                    <app-broadcasting *ngIf="Urlparams && Urlparams['component']== 'broadcasting'"></app-broadcasting>
                    <app-mandatory-themes *ngIf="Urlparams && Urlparams['component']== 'mandatorythemes'"></app-mandatory-themes>
                    <app-admin-listof-dgcs *ngIf="Urlparams && Urlparams['component']== 'adminlistofDGCs'"></app-admin-listof-dgcs>
                    <app-state-listof-dgcs *ngIf="Urlparams && Urlparams['component']== 'statelistofDGCs'"></app-state-listof-dgcs>
                    <app-dgc-meeting-reports *ngIf="Urlparams && Urlparams['component']=='dgcmeetingreports'" [selectedlanguage]="lang"></app-dgc-meeting-reports>
                    <app-admin-dgcreports *ngIf="Urlparams && Urlparams['component']=='admin-dgcreports'" [selectedlanguage]="lang"></app-admin-dgcreports>
                    <app-state-dgcreports *ngIf="Urlparams && Urlparams['component']=='state-dgcreports'" [selectedlanguage]="lang"></app-state-dgcreports>
                    <app-meeting-attendance-report *ngIf="Urlparams && Urlparams['component']=='meeting-attendance-report'" [selectedlanguage]="lang"></app-meeting-attendance-report>
                  </div>
                </div>
              </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
